import { Container } from '@/components';
import React from 'react';
import { Link } from 'react-router-dom';
import ProposalSchool from './ProposalSchool';
import ProgressBarTabs from './ProgressBarTabs';

const BtsProposal = () => {
  return (
    <Container title="BTS Proposal">
      <div className="mb-6 ml-10">
        <Link
          to="/bts"
          className="inline-flex items-center text-blue-600 hover:text-blue-800 font-medium transition-colors duration-150 group">
          <svg
            className="w-5 h-5 mr-1 group-hover:-translate-x-1 transition-transform duration-150"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            viewBox="0 0 24 24"
            aria-hidden="true">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M15 19l-7-7 7-7"
            />
          </svg>
          <span>Back to BTS</span>
        </Link>
      </div>
      <ProposalSchool />
      <ProgressBarTabs />
    </Container>
  );
};

export default BtsProposal;
